export const ContractSettleRouting = [
  {
    path: "/purchase/contractSettle/list",
    name: "purchase-contractSettle-list",
    meta: { title: "采购合同结算记录" },
    notice: { type: "purchase_contract_settle", hasNotice: false },
    component: () => import("@/views/purchase/contract-settle/list/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/contractSettle/create",
    name: "purchase-contractSettle-create",
    meta: { title: "新增采购合同结算", comName:"PurchaseContractSettleFormCreate"  },
    component: () => import("@/views/purchase/contract-settle/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/contractSettle/edit/:id",
    name: "purchase-contractSettle-edit",
    meta: { title: "编辑采购合同结算", comName:"PurchaseContractSettleFormCreate" },
    component: () => import("@/views/purchase/contract-settle/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/contractSettle/detail/:id",
    name: "purchase-contractSettle-detail",
    meta: { title: "采购合同结算详情" },
    component: () => import("@/views/purchase/contract-settle/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/purchase/contractSettle/flowPrint/:id",
    name: "purchase-contractSettle-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "project-profile" */ "@/views/purchase/contract-settle/flow-print/index.vue"
      ),
  },
];
